<template>
  <div>
    <ContentHeader :order-nav="false" />
    <div class="content-container">
      <el-table :data="orderList" class="while-data-table" v-loading="listLoading">
        <el-table-column label="图片">
          <template slot-scope="scope">
            <div class="item-image">
              <img :src="getImageUrl(scope.row.detailList[0])" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="产品名称" prop="detailList[0].itemName"></el-table-column>
        <el-table-column label="需求部门" prop="applyBu"></el-table-column>
        <el-table-column label="需求人" prop="applyPerson"></el-table-column>
        <el-table-column label="最低开机量" prop="detailList[0].moqProductionBatch">
          <template slot-scope="scope">
            {{scope.row.detailList[0].moqProductionBatch | thousandSymbol}}
          </template>
        </el-table-column>
        <el-table-column label="单个地址最低起订量" prop="detailList[0].moqDeliveryAddress" width="160">
          <template slot-scope="scope">
            {{scope.row.detailList[0].moqDeliveryAddress | thousandSymbol}}
          </template>
        </el-table-column>
        <el-table-column label="订购总数量" prop="detailList[0].ttlQty">
          <template slot-scope="scope">
            {{scope.row.detailList[0].ttlQty | thousandSymbol}}
          </template>
        </el-table-column>
        <el-table-column label="需求状态" prop="requirementStatusName"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="btn-red" size="mini" @click="handleView(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="while-data-table-footer">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import ContentHeader from '@/components/content-header'
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      orderList: [],
      total: null,
      listLoading: false,
      queryParam: {
        page: 1,
        pageSize: 10
      }
    }
  },
  created () {
    this.queryOrderMore()
  },
  methods: {
    // 获取non-menu大于五万订单列表
    queryOrderMore () {
      this.listLoading = true
      this.$store.dispatch('queryOrderMore', this.queryParam).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.orderList = res.data.resultData.purchaseRequirementList || []
          this.total = res.data.resultData.pageInfo.totalCounts
        }
      })
    },

    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryOrderMore()
    },

    // 查看详情
    handleView (row) {
      this.$router.push({
        path: `/material/non-menu-more-view/${row.requirementId}`
      })
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.fileList && item.fileList.length > 0) {
        imageUri = item.fileList[0].fileUri
      }
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="scss" scoped>
.while-data-table {
  margin-top: $content-large;
}
.while-data-table-footer {
  width: 1200px;
  box-sizing: border-box;
  padding-top: 10px;
  margin: $content-middle auto 0 auto;
}
.item-image {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 100%;
    max-height: 100%;
    border: none;
  }
}
</style>
